import React from 'react';
import {
	Modal,
	ModalOverlay,
	ModalContent,
	ModalHeader,
	ModalBody,
	ModalFooter,
	ModalCloseButton,
	Button,
	Text,
	List,
	ListItem,
	Box,
} from '@chakra-ui/react';

interface TemplateDetailsModalProps {
	isOpen: boolean;
	onClose: () => void;
	template: any | null;
}

const TemplateDetailsModal: React.FC<TemplateDetailsModalProps> = ({
	isOpen,
	onClose,
	template,
}) => {
	if (!template) {
		return null;
	}

	return (
		<Modal isOpen={isOpen} onClose={onClose} isCentered size="lg">
			<ModalOverlay />
			<ModalContent>
				<ModalHeader>Template Details</ModalHeader>
				<ModalCloseButton />
				<ModalBody>
					<List spacing={2}>
						<ListItem>
							<Text fontWeight="bold">Name:</Text> {template.name}
						</ListItem>
						<ListItem>
							<Text fontWeight="bold">ID:</Text> {template.templateId}
						</ListItem>
						{Array.isArray(template.tags) && template.tags.length > 0 && (
							<ListItem>
								<Text fontWeight="bold">Tags:</Text>
								<Box mt={1}>
									{template.tags.map((tag: any, idx: number) => (
										<Text key={idx} fontSize="sm" color="gray.700">
											{tag.key}: {tag.value}
										</Text>
									))}
								</Box>
							</ListItem>
						)}
					</List>
				</ModalBody>
				<ModalFooter>
					<Button onClick={onClose}>Close</Button>
				</ModalFooter>
			</ModalContent>
		</Modal>
	);
};

export default TemplateDetailsModal;
